import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';

// for tracking user activity
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  activateRoute: string;
  currentUser: any;

  loginUser: any;
  timedOut = false;
  lastPing?: Date = null;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    public idle: Idle,
    private keepalive: Keepalive
  ) {
    router.events.subscribe((activeRoute: any) => {
      this.activateRoute = activeRoute.url;
    });

    // sets an idle timeout of 5 seconds, for testing purposes.
  }

  ngOnInit(): void {
    const user = this.authService.userValue;
    // this.currentUser = this.authService.userValue;

    if (this.activateRoute === '/') {
      switch (user.user.role_id) {
        case 1:
          // * Admin
          this.router.navigate(['/nip']);
          break;
        case 2:
          // * Tehnolog
          this.router.navigate(['/operations']);
          break;
        case 3:
          // * Prodavac
          this.router.navigate(['/nip']);
          break;
        case 4:
          // * Sef proizvodnje
          this.router.navigate(['/nip']);
          break;
        case 5:
          // * Radnik
          this.router.navigate(['/nip-worker']);
          break;
        default:
      }
    }
  }

  ngOnDestroy() {
    this.currentUser = null;
    this.loginUser = null;
  }

  ngAfterViewInit(): void {}
  reset() {
    this.idle.watch();
    this.timedOut = false;
  }
}
